import React from "react";
import {BrowserRouter as Router,Route,Switch} from 'react-router-dom'
import Navbar from './component/Navbar'
import Home from './component/Home'
import About from './pages/About'
import MovieDB from "./component/MovieDB";
import Footer from "./component/Footer";
import MovieDBnav from './component/MovieDBnav'

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path='/'>
          <Navbar/>
          <Home/>
        </Route>
        <Route path='/about'>
          <MovieDBnav/>
          <About/>
        </Route>
        <Route path='/movies/:id'>
          <MovieDBnav/>
          <MovieDB/>
        </Route>
      </Switch>
      <Footer/>
    </Router>
  )
}

export default App;
